import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { CloseOutlined, ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Box,
} from "@mui/material";
import { useState } from "react";

interface CustomAccordionProps {
  title?: string;
  children: ReactJSXElement;
  handleClose?: Function;
}

export default function CustomAccordion(props: CustomAccordionProps) {
  const { title, children, handleClose = () => {} } = props;

  const [open, setOpen] = useState(true);

  return (
    <>
      <Accordion expanded={open} sx={{ height: "140%" }}>
        <AccordionSummary>
          <Grid container>
            <Grid
              item
              lg={11}
              xs={11}
              onClick={() => setOpen((open) => !open)}
              className="verticalCenter"
            >
              <span>{title}</span>
            </Grid>
            <Grid item lg={1} xs={1}>
              <div className="pullRight">
                <Button
                  onClick={() => setOpen((open) => !open)}
                  sx={{ minWidth: "10px", maxWidth: "30px" }}
                >
                  {open ? <ExpandLess /> : <ExpandMore />}
                </Button>
                <Button
                  sx={{ minWidth: "10px", maxWidth: "30px" }}
                  onClick={() => handleClose()}
                >
                  <CloseOutlined sx={{ fontSize: "20px" }} />
                </Button>
              </div>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <>
            {children}
            <Box sx={{ height: "20px" }} />
          </>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
